module.exports = __webpack_public_path__ + "img/series-transpose.72051dcf.svg";